export default {
  "nl": {
    "integration_error": {
      "customer": {
        "first_name": {
          "blank": "First name can't be blank."
        },
        "last_name": {
          "blank": "Last name can't be blank."
        },
        "phone": {
          "blank": "Phone number can't be blank."
        },
        "user": {
          "taken": "Email address must be unique."
        }
      }
    }
  }
}